import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { resourcesInstallations } from "../../helpers/backend_helper";
import { useFormik } from "formik";

import {
  Container,
  Col,
  Row,
  Button,
  Form,
} from "reactstrap";
import {
  initialValues,
  parseFormValues,
  validationSchema,
} from "./Sections/yup.validation";
import General from "./Sections/General";
import CardLoader from "../../components/Common/CardLoader";
import VehicleFiles from "./Sections/VehicleFiles";
import OperativeTests from "./Sections/OperativeTests";
import Conditions from "./Sections/Conditions";
import * as _ from "lodash";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const EditShowInstall = () => {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [installation, setInstallation] = useState();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      const parsedValues = parseFormValues(values);
      save(parsedValues);
    },
  });

  const save = (data) => {
    setIsUpdating(true);
    resourcesInstallations("put", data, id)
      .then(responseSaveAction)
      .finally(() => {
        setIsUpdating(false);
      });
  };

  const responseSaveAction = (response) => {
    if (response.status) {
      console.log("Installation updated");
      return;
    }
  };

  useEffect(() => {
    setIsLoading(true);
    resourcesInstallations("show", {}, id)
      .then(responseAction)
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const responseAction = (response) => {
    if (response.status) {
      const { installation } = response;
      const files = _.keyBy(installation.files, "name");

      validation.setValues({
        ...validation.values,
        ...installation,
        files: {
          ...validation.values.files,
          ...files,
        },
      });

      setInstallation(installation);
    }
  };

  document.title = "Instalación | Instalaciones";

  if (isLoading)
    return (
      <div className="page-content">
        <CardLoader title="Cargando datos de la instalación" />
      </div>
    );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col lg="12">
                <h2>Editar Instalación</h2>
                <div>
                  <General validation={validation} />
                  <Conditions
                    selected={installation?.vehicleConditions}
                    validation={validation}
                  />
                  <OperativeTests
                    selected={installation?.operativeTests}
                    validation={validation}
                  />
                  <VehicleFiles validation={validation} />
                </div>
              </Col>
            </Row>
            <Row className="my-4">
              <Col className="text-center">
                <Link to="/instalaciones" className="btn btn-secondary me-2"><i className="fa fa-reply"></i> Regresar</Link>
                <Button color="primary" type="submit" disabled={isUpdating}>
                  <i className="fa fa-save"></i> {isUpdating ? "Guardando..." : "Guardar"}
                </Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditShowInstall;
